import React, { useState } from 'react';
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
  CircularProgress,
  Link
} from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import PasswordChangeDialog from '../components/PasswordChangeDialog';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPasswordChangeDialog, setShowPasswordChangeDialog] = useState(false);
  const [tempPasswordUser, setTempPasswordUser] = useState(null);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(email, password);

    if (result.success) {
      if (result.user.role === 'Dealer' && result.user.password_tmp === 'YES') {
        setTempPasswordUser(result.user);
        setShowPasswordChangeDialog(true);
        setLoading(false);
        return;
      }

      if (result.user.role === 'SuperAdmin' || result.user.role === 'Sales') {
        navigate('/admin');
      } else if (['Admin', 'Manager'].includes(result.user.role)) {
        navigate('/manufacturer');
      } else if (result.user.role === 'Dealer') {
        navigate('/dealer');
      } else {
        navigate('/');
      }
    } else {
      setError(result.error);
    }

    setLoading(false);
  };

  const handlePasswordChangeSuccess = () => {
    if (tempPasswordUser) {
      navigate('/dealer');
    }
    setTempPasswordUser(null);
  };

  const handlePasswordChangeClose = () => {
    setShowPasswordChangeDialog(false);
    setTempPasswordUser(null);
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 8, mb: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom align="center">
          Login to SMOD
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>
            {error}
          </Alert>
        )}

        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
          <TextField
            fullWidth
            label="Email"
            type="text"
            inputProps={{ inputMode: 'email' }}
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            margin="normal"
            required
            autoFocus
          />

          <TextField
            fullWidth
            label="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            margin="normal"
            required
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : 'Login'}
          </Button>

          <Box sx={{ textAlign: 'center', mt: 2 }}>
            <Link
              component="button"
              variant="body2"
              onClick={() => navigate('/forgot-password')}
              sx={{ cursor: 'pointer' }}
              type="button"
            >
              Forgot Password?
            </Link>
          </Box>
        </Box>
      </Paper>
      <PasswordChangeDialog
        open={showPasswordChangeDialog}
        onClose={handlePasswordChangeClose}
        onSuccess={handlePasswordChangeSuccess}
        user={tempPasswordUser}
      />
    </Container>
  );
};

export default Login;
